import * as Popover from "@radix-ui/react-popover"
import { useState } from "react"
import "./select.css"
import { Clear, DownOutlined } from "./icons"
import { translate } from "../app"
import { translations } from "../translations"

interface Option {
  label: string
  value: string
}

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, "onSelect"> {
  options: Option[]
  placeholder?: string
  onSelect?: (data: { key?: string; label: string; value: string }) => void
  listHeight?: number
  allowClear?: boolean
  onClear?: () => void
  filterOption?: (inputValue: string, option: any) => boolean
  isRtl?: boolean
}

export function Select(props: Props) {

  let { options, placeholder, onSelect, listHeight, allowClear, onClear, filterOption, isRtl } = props
  const [value, setValue] = useState<string>("")
  const [option, setOption] = useState<{ label: string; value: string } | null>(null)

  function onClearInternal() {
    setValue("")
    setOption(null)
    onClear?.()
  }

  function onChange(value: string) {
    setOption(null)
    if (!value) {
      onClearInternal()
    } else {
      setValue(value)
    }
  }

  function onSelectInternal(o: Option) {
    setOption(o)
    setValue(o.label)
    onSelect?.(o)
  }

  function onBulr() {
    if (!option) {
      onClearInternal()
    }
  }

  listHeight = listHeight || 400
  options = options || []
  filterOption = filterOption || ((inputValue: string, option: any) => true)


  options = options.filter((option) => filterOption(value, option))

  return <Popover.Root>
    <Popover.Trigger asChild className="w-full">
      <div className="w-full flex border-gray-300 border-solid border rounded p-1 text-black focus-within:border-blue-400" dir={isRtl ? "rtl" : "ltr"}>
        <div className="flex-grow pr-4 justify-center items-center flex">
          <input
            type="text"
            className="w-full outline-none border-0 placeholder:text-gray-300 pt-1 pl-1 text-base"
            placeholder={placeholder}
            aria-label={placeholder}
            onChange={(e) => onChange(e.target.value)}
            onBlur={onBulr}
            value={value} />
        </div>
        <div className="pt-1 pr-1 text-sm text-gray-300 flex items-center justify-center">
          {value ? <button type="button" className="cursor-pointer bg-transparent border-0 p-0" aria-label={translate(translations.close)} onClick={() => onClearInternal()}><Clear aria-hidden="true" /></button> : <DownOutlined aria-hidden="true" />}
        </div>
      </div>
    </Popover.Trigger>
    <Popover.Portal>
      <Popover.Content
        id="popover-content"
        className="text-black rounded overflow-y-auto overflow-x-hidden bg-white p-2 shadow-[0_10px_38px_-10px_hsla(206,22%,7%,.35),0_10px_20px_-15px_hsla(206,22%,7%,.2)] PopoverContent"
        style={{ maxHeight: listHeight }}
        sideOffset={5}
        onOpenAutoFocus={(e) => e.preventDefault()}
        asChild
      >
        <div>
          {options.map((item, index) => (
            <div className="cursor-pointer py-2 pl-2 w-full text-sm overflow-x-hidden hover:bg-gray-100 text-ellipsis whitespace-nowrap " key={item.value} onMouseDown={(e) => {
              e.preventDefault()
              onSelectInternal(item)
            }} >
              {item.label}
            </div>
          ))}
        </div>
      </Popover.Content>
    </Popover.Portal>
  </Popover.Root>
}